export const anchorSmoothScroll = (idSelector: string, offset = 0): void => {
  const yOffset = offset
  const target = document.querySelector(idSelector)
  const y = target?.getBoundingClientRect().top + window.pageYOffset + yOffset

  window.scrollTo({ behavior: 'smooth', top: y })
}
